export default __webpack_public_path__ + "static/priceline-8892458dd1c8969c436a63980dbba70d.png";